import { createAction } from '@reduxjs/toolkit'

export const removeBoard = createAction<{ projectId: number; boardId: number }>(
  'taskTracker/boardCleanup/removeBoard',
)
